/**
 * DS-1323 — FileCard error tone colours on the reworked tier, behind
 * `release-experimental-design-system-forms`. Same four roles as
 * `fileCardErrorToneClasses`, each mapped by **what it paints**, so the legacy
 * one-name-many-properties ambiguity does not survive the migration.
 *
 * | Part       | Legacy                          | Reworked                             | Owes            |
 * | ---------- | ------------------------------- | ------------------------------------ | --------------- |
 * | container  | `validation-destructive`        | `semantic-border-destructive-strong` | 3:1 vs surface  |
 * | iconFrame  | `validation-destructive/10`     | `semantic-background-destructive`    | — (surface)     |
 * | icon       | `validation-destructive`        | `semantic-fill-destructive`          | 3:1 vs the tint |
 * | meta       | `validation-destructive`        | `semantic-text-destructive`          | 4.5:1 vs surface|
 *
 * Measured (newBrand / newBrandDark): container 3.91 / 4.58, icon on the tint
 * 3.41 / 4.61, meta 5.21 / 8.51.
 *
 * Three deliberate choices:
 *
 * - **container is `-strong`, not the plain border role.** The card edge *is*
 *   the error signal, so it is a non-text indicator owing 3:1 (WCAG 1.4.11).
 *   Plain `semantic-border-destructive` is a feather border at 1.28:1 — see
 *   DS-1527. The ticket's original description said `semantic-border-destructive`;
 *   that predates the feather/strong split.
 * - **iconFrame drops the `/10` alpha.** The legacy tint fakes a soft surface by
 *   fading the solid token. The reworked tier has a real one, so this becomes a
 *   token swap rather than an opacity trick — and it stops the tint shifting
 *   whenever the solid value moves.
 * - **icon and meta diverge**, though the legacy tier gave both the same class.
 *   The glyph is a non-text indicator (3:1) and the line beneath it is text
 *   (4.5:1). One legacy name, two properties — exactly the split the reworked
 *   tier exists to make explicit.
 */
export const fileCardErrorToneClassesExperimental = {
  container: 'border-semantic-border-destructive-strong',
  iconFrame: 'bg-semantic-background-destructive',
  icon: 'text-semantic-fill-destructive',
  meta: 'text-semantic-text-destructive',
} as const;
